const GetUrl = (generatedUrl, serviceType, useProxy, proxyServer) => {
    if (useProxy) {
        const maps = generatedUrl.split("?");
        if (maps.length === 2) {
            return GetScheme(serviceType) + proxyServer + "/speech/proxy/type/" + serviceType + "?" + maps[1];
        } else if (maps.length === 1) {
            return GetScheme(serviceType) + proxyServer + "/speech/proxy/type/" + serviceType;
        }
    }

    return generatedUrl;
};

const GetScheme = serviceType => {
    switch (serviceType) {
        case 0: //Azure
        default:
            return "https://";
        case 1: //XunFei
            return "wss://";
        case 2: //XunFeiASR
            return "wss://";
        case 3: //XunFeiIAT
            return "wss://";
        case 4: //AliYunIAT
            return "https://";
        case 5: //AliYunIntIAT
            return "https://";
        case 6: //AzureIAT
            return "https://";
    }
};

export default { GetUrl, GetScheme };
